import { PMCategoryProgressCard } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { getLocalizedCardCopy } from "../../../utils/get-localized-card-copy";
import { DashboardCardContext } from "../context";

export function addCompletedItemsPerCategoryLevelCard(
  ctx: DashboardCardContext
) {
  const {
    view,
    language,
    settings,
    itemName,
    itemNamePlural,
    projectName,
    projectNamePlural,
    getCardCopy,
  } = ctx;
  const categoryLabel =
    settings?.configuration?.fieldsDefinition?.find(
      (field) => field.fieldName === "dropdownFieldOne"
    )?.label ?? getLocalizedMessage(language, "category");

  const completedItemsPerCategoryLevelComponent = view.addComponent({
    component: PMCategoryProgressCard,
    layoutProps: {
      componentId: "completedItemsPerCategoryLevelComponent",
      labels: ["progress"],
      description: getCardCopy(language, "completedItemsByCategoryLevel", {
        categoryLabel,
      }).description,
      title: getCardCopy(language, "completedItemsByCategoryLevel", {
        categoryLabel,
      }).title,
    },
  });

  completedItemsPerCategoryLevelComponent.mapLayoutProps(
    ({ language, settings }) => {
      const currentLanguage = language || "en";
      const categoryLabel =
        settings?.configuration?.fieldsDefinition?.find(
          (field) => field.fieldName === "dropdownFieldOne"
        )?.label ?? getLocalizedMessage(currentLanguage, "category");

      return {
        componentId: "completedItemsPerCategoryLevelComponent",
        labels: ["progress"],
        description: getCardCopy(
          currentLanguage,
          "completedItemsByCategoryLevel",
          {
            categoryLabel,
          }
        ).description,
        title: getCardCopy(currentLanguage, "completedItemsByCategoryLevel", {
          categoryLabel,
        }).title,
      };
    }
  );

  completedItemsPerCategoryLevelComponent.mapState(
    ({ dashboard, settings, language }) => {
      const currentLanguage = language || "en";
      const categoryLabel =
        settings?.configuration?.fieldsDefinition?.find(
          (field) => field.fieldName === "dropdownFieldOne"
        )?.label ?? getLocalizedMessage(currentLanguage, "category");
      const title = getLocalizedCardCopy(
        currentLanguage,
        "completedItemsByCategoryLevel",
        {
          itemName,
          itemNamePlural,
          projectName,
          projectNamePlural,
          categoryLabel,
        }
      ).title;
      return {
        label: title,
        title,
        icon: "BarChart",
        showInfoIcon: false,
        showMenuIcon: false,
        data:
          dashboard?._calculated
            ?.categoryCountsForCompletedItemsPerCategoryLevel ?? [],
      };
    }
  );

  completedItemsPerCategoryLevelComponent.mapVisibility(
    ({ settings }) =>
      settings?.configuration?.fieldsDefinition
        ?.filter((field) => field.purpose === "itemBasic")
        .find((field) => field.fieldName === "dropdownFieldOne")?.enabled ===
      true
  );
}
